import { render, staticRenderFns } from "./Flights.vue?vue&type=template&id=b8c3f21c&scoped=true&"
import script from "./Flights.vue?vue&type=script&lang=js&"
export * from "./Flights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c3f21c",
  null
  
)

export default component.exports